import React, { useState, useEffect } from "react";
import Nav from "./Nav";
import axios from "axios";
import Loader from "../user/Loader";
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import { CgPlayListRemove } from "react-icons/cg";
import { MdPlaylistAdd } from "react-icons/md";
import { useHistory } from "react-router-dom";
import { ImUser, ImUserPlus } from "react-icons/im";

function AddUser() {
    let history = useHistory();
    const [isLoading, setIsLoading] = useState(false);
    const [open, setOpen] = useState(false);
    const [formErrors, setFormErrors] = useState({
        message: "",
        isValidated: true
    });
    const [list_of_locations, setLocation] = useState([]);
    const [userData, setUserData] = useState({
        Name: "",
        Email: "",
        Username: "",
        Password: "",
        LocationId: null
    });

    const handleInputChange = (event) => {
        event.preventDefault();

        if(event.target.name === "LocationId"){
            setUserData({
                ...userData, [event.target.name]: parseInt(event.target.value)
            })
        }
        else{
            setUserData({
                ...userData, [event.target.name]: event.target.value
            });
        }
        
    }


    const addUser = () => {
        console.log(userData);
        let formIsValid = validateInput(userData).isValidated;
        if (formIsValid) {
            setIsLoading(true);
            axios.post(process.env.REACT_APP_BASEURL + process.env.REACT_APP_ADD_USER_URL, userData)
                .then((response) => {
                    setIsLoading(false);
                    setOpen(true);
                })
                .catch(err => {
                    console.log(err);
                })
        }
        else {
            setFormErrors({
                isValidated: false,
                message: "Fill up the inputs correctly!!!"
            });
        }
    }
    const validateInput = (element) => {
        let errors = {
            message: "User Added Successfully",
            isValidated: true
        };
        if (!element.Name) {
            errors.isValidated = false;
        }
        if (!element.LocationId) {
            errors.isValidated = false;
        }
        if (!element.Email) {
            errors.isValidated = false;
        }
        else if (!/\S+@\S+\.\S+/.test(element.Email)) {
            errors.isValidated = false;
        }
        if (!element.Password) {
            errors.isValidated = false;
        }
        if (!element.Username) {
            errors.isValidated = false;
        }
        return errors;
    }

    const handleClose = () => {
        setOpen(false);
        if (formErrors.isValidated) {
            history.push("/users");
        }
        else {
            history.push("/addUser");

        }

    }   
    useEffect(() =>{
        const locationApi = process.env.REACT_APP_BASEURL + process.env.REACT_APP_CAMPUS_LIST_URL;
        axios.get(locationApi)
            .then((res) =>{
                console.log(res);
                setLocation(res.data);
            })
            .catch((err) =>{
                console.log(err);
            })
         } , [])
    

    return (
        <div className="admin-body">
            <Nav
                headerText="ADMIN"
                nav1="Service Setup"
                nav2="Delete Service"
                nav3="Add User"
                nav4="View Users"
                path1="/setupService"
                path2="/removeService"
                path3="/addUser"
                path4="/users"
                icon1={<MdPlaylistAdd />}
                icon2={<CgPlayListRemove />}
                icon3={<ImUserPlus />}
                icon4={<ImUser />}
            />
            <div className="body">
                <div >
                    <div className="body-inner-wrapper">
                        <div className="add-user-wrapper">
                            <div className="header-container">
                                <h2>ADD USER</h2>
                                <hr />
                                <div className="error-message-wrapper" style={formErrors.isValidated === false ? { display: "block" } : { display: "none" }}>
                                    <p>Fill up all inputs correctly!!!</p>
                                </div>
                            </div>
                            <div className="add-user-container">
                                <div>
                                    <input
                                        type="text"
                                        placeholder="Name"
                                        maxLength="30"
                                        className="Name"
                                        name="Name"
                                        onChange={handleInputChange}
                                    />
                                </div>
                                <div>
                                    <input
                                        className="Email"
                                        name="Email"
                                        placeholder="Email"
                                        onChange={handleInputChange}

                                    />
                                </div>
                                <div>
                                    <select name="LocationId" id="LocationId" className="" onChange={handleInputChange}>
                                        <option>Campus Location</option>
                                        {list_of_locations.map(location => {
                                            return <option key={location.locationId} value={location.locationId}>{location.campusLocation}</option>
                                        })
                                        }
                                    </select>
                                </div>
                                <div>
                                    <input
                                        className="Username"
                                        name="Username"
                                        placeholder="Username"
                                        onChange={handleInputChange}

                                    />
                                </div>
                                <div>
                                    <input
                                        className="passWord"
                                        name="Password"
                                        placeholder="Password"
                                        onChange={handleInputChange}
                                    />
                                </div>
                                <div>
                                    <button
                                        type="submit"
                                        className="button"
                                        name="submit"
                                        onClick={addUser}
                                    >
                                        Add
                                    </button>
                                </div>
                                <Dialog
                                    open={open}
                                    onClose={handleClose}
                                    aria-labelledby="alert-dialog-title"
                                    aria-describedby="alert-dialog-description"
                                >
                                    <DialogContent>
                                        <DialogContentText id="alert-dialog-description">
                                            {validateInput(userData).message}
                                        </DialogContentText>
                                    </DialogContent>
                                    <DialogActions>
                                        <Button onClick={handleClose} color="primary">
                                            ok
                                        </Button>
                                    </DialogActions>
                                </Dialog>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Loader state={isLoading} />

        </div>

    )
}
export default AddUser;